import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import NewAddress from "./new-address";
import { CUSTOM_ADDRESS_ID } from "./customAddressId";

const formatAddress = (address) => {
  const parts = [
    "firstName",
    "lastName",
    "address1",
    "address2",
    "city",
    "province_code",
    "zip",
  ];

  return parts
    .map((part) => address[part])
    .filter((v) => v)
    .join(" ");
};

export default function SelectAddress({
  label,
  addresses,
  selectedAddress,
  setSelectedAddress,
  allowCustom = false,
  countries,
}) {
  const [showNewAddress, setShowNewAddress] = useState(
    selectedAddress?.id === CUSTOM_ADDRESS_ID,
  );

  const handleChange = (e) => {
    if (e.target.value === CUSTOM_ADDRESS_ID) {
      setSelectedAddress(null);
      setShowNewAddress(true);
    } else {
      setShowNewAddress(false);

      const matchingAddress = addresses.find(
        ({ id }) => `${id}` === e.target.value,
      );

      setSelectedAddress(matchingAddress || null);
    }
  };

  return (
    <>
      <label className="save-quote__address-label">
        <span className="save-quote__field-label-text">{label}</span>
        <select onChange={handleChange} value={selectedAddress?.id}>
          <option>{window.localeStrings.save_quote.select_address}</option>
          {addresses.map((address) => (
            <option value={address.id} key={address.id}>
              {formatAddress(address)}
            </option>
          ))}
          {allowCustom && (
            <option value={CUSTOM_ADDRESS_ID}>
              {window.localeStrings.save_quote.new_address}
            </option>
          )}
        </select>
      </label>
      {showNewAddress && (
        <NewAddress
          setSelectedAddress={setSelectedAddress}
          countries={countries}
          addressId={CUSTOM_ADDRESS_ID}
        />
      )}
    </>
  );
}
